module.exports = __webpack_public_path__ + "img/icon-voucher-sent.3b7f875d.svg";